/**
 * ! ATENÇÃO
 *
 * se o seu component for pesado, e utiliza biblioteca de terceiros, export da forma abaixo:
 *
 * @example export const MyAsyncComponent = defineAsyncComponent(() => import("./MyAsyncComponent.vue"))
 */

import { defineAsyncComponent } from "vue"

export const Player = defineAsyncComponent(() => import("@/components/common/MediaPlayer/MediaPlayer.vue"))

export const LessonTutor = defineAsyncComponent(() => import("@/pages/watch/components/TutorLesson.vue"))
